// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__Tl_2H","name":"ConsentHeader_name__241pf","birthday":"ConsentHeader_birthday__1C2Wl","skeleton":"ConsentHeader_skeleton__NZUlP"};